import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './plugins/element.js';

Vue.config.productionTip = false;
Vue.config.devtools = true;


router.beforeEach((to, from, next) => {
  // 将路由的name赋给标题
  if(to.name){
    document.title = to.name;
  }
  if (to.matched.some(record => record.meta.requiresAuth)){ // 判断该路由是否需要登录权限
    if (localStorage.getItem('myuser')) { // 判断当前的user_id是否存在 ； 登录存入的user_id
      next();
    } else {
      Vue.prototype.$message.info('请登录');
      next({
        path: '/login',
        query: {redirect: to.fullPath} // 将要跳转路由的path作为参数，传递到登录页面
      })
    }
  } else {
    next();
  }
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
